import { useState, useEffect, useRef, useCallback } from "react";

function loadRecaptchaScript() {
  return new Promise((resolve) => {
    if (window.grecaptcha && window.grecaptcha.render) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js?render=explicit";
    script.async = true;
    script.defer = true;

    script.onload = () => {
      const interval = setInterval(() => {
        if (window.grecaptcha && window.grecaptcha.render) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
    };

    document.head.appendChild(script);
  });
}

export function useRecaptchaV2(siteKey) {
  const captchaRef = useRef(null);
  const widgetIdRef = useRef(null);
  const [token, setToken] = useState(null);

  const onCaptchaSuccess = useCallback((token) => {
    setToken(token);
  }, []);

  const resetCaptcha = useCallback(() => {
    if (window.grecaptcha && widgetIdRef.current !== null) {
      window.grecaptcha.reset(widgetIdRef.current);
      setToken(null);
    }
  }, []);

  useEffect(() => {
    let isMounted = true;

    loadRecaptchaScript().then(() => {
      if (!isMounted) return;

      if (captchaRef.current && widgetIdRef.current === null) {
        widgetIdRef.current = window.grecaptcha.render(captchaRef.current, {
          sitekey: siteKey,
          callback: onCaptchaSuccess,
        });
      }
    });

    return () => {
      isMounted = false;
    };
  }, [siteKey, onCaptchaSuccess]);

  return { captchaRef, token, resetCaptcha };
}
